var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "vue", "noty", "../EventEmitter"], function (require, exports, vue_1, Noty, EventEmitter_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var BatchController = (function (_super) {
        __extends(BatchController, _super);
        function BatchController(options_) {
            var _this = _super.call(this) || this;
            _this.tmp = {
                virtualScreens: [],
                rooms: [],
                locations: []
            };
            _this.options = options_;
            _this.initVue();
            _this.GetData();
            return _this;
        }
        BatchController.prototype.initVue = function () {
            var _this = this;
            var base = this;
            this.vueRoot = new vue_1.default({
                el: this.options.htmlElementSelector,
                data: {
                    locations: [],
                    content: null,
                    selectedScreens: [],
                    selectAll: false,
                    search_text: "",
                    showModal: false,
                    modal: {
                        message: '',
                        callBackName: '',
                        proceedButton: true
                    },
                },
                watch: {
                    selectAll: function (newValue, oldValue) {
                        _this.SetAllLocationsSelectionTo(newValue);
                    }
                },
                components: {
                    'modal': {
                        template: '#modal-template',
                        methods: {
                            ShowProceedButton: function () {
                                return _this.vueRoot.modal.proceedButton;
                            },
                            GetMessage: function () {
                                return _this.vueRoot.modal.message;
                            }
                        }
                    }
                },
                computed: {
                    filtered_locations: function () {
                        var _this = this;
                        var keep_empty = this.search_text === "";
                        var ret = [];
                        this.locations.forEach(function (location) {
                            var includeLocation = false;
                            if (location.CompanyName.toLowerCase().includes(_this.search_text.toLowerCase())) {
                                includeLocation = true;
                            }
                            var rooms = [];
                            location._rooms.forEach(function (room) {
                                var includeRoom = false;
                                if (room.Name.toLowerCase().includes(_this.search_text.toLowerCase())) {
                                    includeRoom = true;
                                }
                                var screens = [];
                                room._virtualScreens.forEach(function (screen) {
                                    if (screen.Name.toLowerCase().includes(_this.search_text.toLowerCase()) || includeLocation || includeRoom) {
                                        screens.push(screen);
                                    }
                                });
                                if (screens.length > 0 || keep_empty) {
                                    var ret_room = {
                                        Id: room.Id,
                                        Name: room.Name,
                                        _virtualScreens: screens,
                                        selected: room.selected,
                                        orig: room
                                    };
                                    rooms.push(ret_room);
                                }
                            });
                            if (rooms.length > 0 || keep_empty) {
                                var ret_location = {
                                    Id: location.Id,
                                    CompanyName: location.CompanyName,
                                    _rooms: rooms,
                                    selected: location.selected,
                                    orig: location
                                };
                                ret.push(ret_location);
                            }
                        });
                        return ret;
                    },
                    updateList: function () {
                        var ret = [];
                        this.selectedScreens.forEach(function (element) {
                            ret.push(element.Id);
                        });
                        return ret;
                    }
                },
                methods: {
                    ClearSelection: function () {
                        _this.vueRoot.locations.forEach(function (location) {
                            location._rooms.forEach(function (room) {
                                room._virtualScreens.forEach(function (screen) {
                                    screen.selected = false;
                                });
                                room.selected = false;
                            });
                            location.selected = false;
                        });
                        _this.vueRoot.selectedScreens.forEach(function (element) {
                            element.selected = false;
                        });
                        _this.vueRoot.selectedScreens = [];
                    },
                    SelectVisible: function () {
                        _this.SetAllLocationsSelectionTo(true);
                    },
                    DeselectVisible: function () {
                        _this.SetAllLocationsSelectionTo(false);
                    },
                    Update: function () {
                        _this.PerformBatch();
                    },
                    ShowConfirm: function () {
                        this.showModal = true;
                    },
                    CloseConfirm: function () {
                        this.showModal = false;
                    },
                    ConfirmProceed: function () {
                        _this.vueRoot[_this.vueRoot.modal.callBackName]();
                        _this.vueRoot.CloseConfirm();
                    },
                    LocationSelectionChange: function (location) {
                        _this.SetLocationsSelectionTo(location, location.selected);
                    },
                    RoomSelectionChange: function (room) {
                        _this.SetRoomsSelectionTo(room, room.selected);
                    },
                    VirtualScreenSelectionChange: function (virtualScreen) {
                        _this.SetVirtualScreenSelectionTo(virtualScreen, virtualScreen.selected);
                    },
                    SelectContent: function () {
                        var cs = new window["contenSelectorClass"]({});
                        cs.AddEventListener("contentSelected", function (sender, content) {
                            _this.vueRoot.content = content;
                        });
                    },
                    GetThumbnail: function () {
                        var thumbUrl = "/images/placeholder/image-placeholder.png";
                        if (_this.vueRoot.content != null && _this.vueRoot.content.Items != undefined)
                            for (var _i = 0, _a = _this.vueRoot.content.Items; _i < _a.length; _i++) {
                                var item = _a[_i];
                                if (item.Purpose == 'thumbnail')
                                    thumbUrl = item.Url;
                            }
                        return thumbUrl;
                    },
                    AskForBatchWithContent: function () {
                        if (_this.vueRoot.content == null) {
                            _this.vueRoot.modal.proceedButton = false;
                            _this.vueRoot.modal.message = 'Es wurde kein Content ausgewählt';
                            _this.vueRoot.showModal = true;
                        }
                        else if (_this.vueRoot.updateList.length < 1) {
                            _this.vueRoot.modal.proceedButton = false;
                            _this.vueRoot.modal.message = 'Es wurden keine Anzeigen ausgewählt';
                            _this.vueRoot.showModal = true;
                        }
                        else {
                            _this.vueRoot.modal.proceedButton = true;
                            _this.vueRoot.modal.callBackName = 'StartBatchWithContent';
                            _this.vueRoot.modal.message = 'Der Content "' + _this.vueRoot.content.Name + '" wird auf ' + _this.vueRoot.updateList.length + ' Anzeige(n) übertragen.';
                            _this.vueRoot.showModal = true;
                        }
                    },
                    AskForClearBatch: function () {
                        if (_this.vueRoot.updateList.length < 1) {
                            _this.vueRoot.modal.proceedButton = false;
                            _this.vueRoot.modal.message = 'Es wurden keine Anzeigen ausgewählt';
                            _this.vueRoot.showModal = true;
                        }
                        else {
                            _this.vueRoot.modal.proceedButton = true;
                            _this.vueRoot.modal.callBackName = 'StartClearBatch';
                            _this.vueRoot.modal.message = 'Content von ' + _this.vueRoot.updateList.length + ' Anzeige(n) wird gelöscht.';
                            _this.vueRoot.showModal = true;
                        }
                    },
                    StartBatchWithContent: function () {
                        _this.PerformBatch();
                    },
                    StartClearBatch: function () {
                        _this.PerformClearBatch();
                    },
                    ClearContent: function () {
                        _this.vueRoot.content = null;
                    }
                }
            });
        };
        BatchController.prototype.SetAllLocationsSelectionTo = function (val) {
            for (var i in this.vueRoot.filtered_locations)
                this.SetLocationsSelectionTo(this.vueRoot.filtered_locations[i], val);
        };
        BatchController.prototype.SetLocationsSelectionTo = function (location, val) {
            location.selected = val;
            if (location.orig) {
                location.orig.selected = val;
            }
            for (var i in location._rooms)
                this.SetRoomsSelectionTo(location._rooms[i], val);
        };
        BatchController.prototype.SetRoomsSelectionTo = function (room, val) {
            room.selected = val;
            if (room.orig) {
                room.orig.selected = val;
            }
            for (var i in room._virtualScreens)
                this.SetVirtualScreenSelectionTo(room._virtualScreens[i], val);
        };
        BatchController.prototype.SetVirtualScreenSelectionTo = function (virtualScreen, val) {
            virtualScreen.selected = val;
            if (val && this.vueRoot.selectedScreens.indexOf(virtualScreen) == -1) {
                this.vueRoot.selectedScreens.push(virtualScreen);
            }
            if (!val && this.vueRoot.selectedScreens.indexOf(virtualScreen) != -1) {
                this.vueRoot.selectedScreens.splice(this.vueRoot.selectedScreens.indexOf(virtualScreen), 1);
            }
        };
        BatchController.prototype.PerformBatch = function () {
            var _this = this;
            console.log("PerformBatch");
            var loadingNoty = new Noty({
                text: "Der Batch-Prozess wurde gestartet. Haben Sie einen Moment Geduld.",
                type: 'info',
                theme: 'metroui'
            }).show();
            $.ajax({
                method: "POST",
                url: this.options.batchSetContentApiUrl.replace(/{contentid}/g, this.vueRoot.content.Id),
                contentType: "application/json",
                dataType: "json",
                data: JSON.stringify(this.vueRoot.updateList)
            })
                .then(function (response) {
                _this.ShowSuccess(response);
            }, function (response) {
                _this.ShowError(response);
            }).always(function () {
                loadingNoty.close();
            });
        };
        BatchController.prototype.PerformClearBatch = function () {
            var _this = this;
            console.log("Perform clear Batch");
            var loadingNoty = new Noty({
                text: "Der Batch-Prozess wurde gestartet. haben Sie einen Moment Geduld.",
                type: 'info',
                theme: 'metroui'
            }).show();
            $.ajax({
                method: "POST",
                url: this.options.batchClearContentApiUrl,
                contentType: "application/json",
                dataType: "json",
                data: JSON.stringify(this.vueRoot.updateList)
            })
                .then(function (response) {
                _this.ShowSuccess(response);
            }, function (response) {
                _this.ShowError(response);
            }).always(function () {
                loadingNoty.close();
            });
        };
        BatchController.prototype.ShowSuccess = function (e) {
            new Noty({
                text: "Der Befehl wurde erfolgreich ausgeführt.<br/>Anzeigen aktualisiert: " + e.UpdatedCount,
                type: 'success',
                theme: 'metroui',
                timeout: 4000
            }).show();
        };
        BatchController.prototype.ShowError = function (e) {
            var description = "";
            try {
                for (var key in e.responseJSON) {
                    if (typeof (e.responseJSON[key]) != "string" && e.responseJSON[key]["length"] != undefined) {
                        description += key + ":<br/>";
                        for (var key2 in e.responseJSON[key]) {
                            description += "&nbsp;&nbsp;" + e.responseJSON[key][key2] + "<br/>";
                        }
                    }
                    else
                        description += key + ": " + e.responseJSON[key] + "<br/>";
                }
            }
            catch (e) {
                console.log("error @@ playlist edit/create:" + e);
            }
            new Noty({
                text: 'Der Befehl konnte nicht ausgeführt werden. ' +
                    '<br/>Fehler: <br/>' + (description != "" ? description : e.statusText) +
                    '<br/>xhr-status:' + e.status +
                    '<br/>xhr-statusText:' + e.statusText,
                type: 'error',
                theme: 'metroui',
                timeout: 6000
            }).show();
        };
        BatchController.prototype.GetData = function () {
            var _this = this;
            jQuery.get(this.options.readApiUrl).then(function (virtualScreens) {
                _this.tmp.virtualScreens = virtualScreens;
                _this.CheckDataAndProccedWithRendering();
            }, function (response) {
                new Noty({
                    text: "Die Daten konnten leider nicht geladen werden. Laden Sie die Seite neu. Wenn das Problem weiterhin besteht, wenden Sie sich an Ihren technischen Ansprechpartner.",
                    type: 'error',
                    theme: 'metroui',
                    timeout: 6000
                }).show();
            });
            jQuery.get(this.options.readApiUrlRooms).then(function (rooms) {
                _this.tmp.rooms = window.Enumerable.from(rooms)
                    .where(function (item) { return item.Location; })
                    .orderByDescending(function (item) { return item.Location.CompanyName; })
                    .select(function (item) { item["selected"] = false; item.Location["selected"] = false; return item; })
                    .toArray();
                _this.CheckDataAndProccedWithRendering();
            }, function (response) {
                new Noty({
                    text: "Die Daten konnten leider nicht geladen werden. Laden Sie die Seite neu. Wenn das Problem weiterhin besteht, wenden Sie sich an Ihren technischen Ansprechpartner.",
                    type: 'error',
                    theme: 'metroui',
                    timeout: 6000
                }).show();
            });
        };
        BatchController.prototype.CheckDataAndProccedWithRendering = function () {
            if (this.tmp.virtualScreens.length == 0 || this.tmp.rooms.length == 0)
                return false;
            this.tmp.locations = window.Enumerable.from(this.tmp.rooms)
                .where(function (item) { return item.Location; })
                .select(function (item) { return item.Location; })
                .distinct(function (item) { return item.Id; })
                .toArray();
            var _loop_1 = function () {
                var locationId = this_1.tmp.locations[i].Id;
                this_1.tmp.locations[i]["_rooms"] = window.Enumerable.from(this_1.tmp.rooms)
                    .where(function (item) { return item.Location.Id == locationId; })
                    .orderByDescending(function (item) { return item.Name; })
                    .select(function (item) { return item; })
                    .toArray();
                var _loop_2 = function (i2) {
                    var roomId = this_1.tmp.locations[i]["_rooms"][i2].Id;
                    this_1.tmp.locations[i]["_rooms"][i2]["_virtualScreens"] = window.Enumerable.from(this_1.tmp.virtualScreens)
                        .where(function (item) { return item.RoomId == roomId; })
                        .orderByDescending(function (item) { return item.Name; })
                        .select(function (item) { item["selected"] = false; return item; })
                        .toArray();
                };
                for (var i2 in this_1.tmp.locations[i]["_rooms"]) {
                    _loop_2(i2);
                }
            };
            var this_1 = this;
            for (var i in this.tmp.locations) {
                _loop_1();
            }
            this.vueRoot.locations = this.tmp.locations;
        };
        return BatchController;
    }(EventEmitter_1.EventEmitter));
    exports.BatchController = BatchController;
    $(function () {
        var optionsList = window["BatchControllerData"];
        for (var i in optionsList) {
            window["BatchController" + i] = new BatchController(optionsList[i]);
        }
    });
});
//# sourceMappingURL=BatchController.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Controllers/BatchController.js
// module id = 402
// module chunks = 0